<div class="row">
  <div class="col-lg-12">
    <ol class="breadcrumb">
      <li><a (click)="redirectToUrl('missioncontrol.dashboard', true)">Home</a></li>
      <li class="active"><span></span></li>
    </ol>
    <h1 class="heading-css">Formalized Text</h1>
  </div>
</div>
<div class="row" id="ai-activities-content">
  <div class="col-xs-12">
    <app-ai-activities></app-ai-activities>
  </div>
</div>
